module.exports = __webpack_public_path__ + "static/media/MSMEBen8.3c774f84.svg";